import type { StayDaySourceInput } from "@/lib/daycare-hotel/stayDays";
import type { ReservationFormValues } from "./reservationForm";

type DateValues = Pick<
  ReservationFormValues,
  "moduleType" | "checkInDate" | "checkOutDate" | "recurrence" | "dateMode" | "pickedDates" | "excludedDates"
>;

/**
 * A única tradução do formulário para as datas da reserva. Diálogo, comanda,
 * holds e gravação leem daqui, senão cada um contaria um número de diárias.
 */
export function stayDaySourceFromValues(values: DateValues): StayDaySourceInput {
  const moduleType = values.moduleType === "hotel" ? "hotel" : "daycare";
  // Sem `dateMode` (chamadas antigas), uma regra presente quer dizer repetir.
  const mode = moduleType === "hotel" ? "single" : values.dateMode ?? (values.recurrence ? "repeat" : "single");
  return {
    moduleType,
    checkInDate: values.checkInDate,
    checkOutDate: values.checkOutDate ?? null,
    // Sem data final a regra ainda não descreve datas: vale o dia único.
    recurrence: mode === "repeat" && values.recurrence && values.recurrence.endsOn
      ? {
          frequency: values.recurrence.frequency,
          interval: values.recurrence.interval,
          weekdays: values.recurrence.weekdays,
          monthday: values.recurrence.monthday,
          endsOn: values.recurrence.endsOn,
        }
      : null,
    pickedDates: mode === "pick" ? values.pickedDates ?? [] : [],
    excludedDates: mode === "repeat" ? values.excludedDates ?? [] : [],
  };
}
